export const LEI_SHAPE_PATTERN = /^[A-Za-z0-9]{18}[0-9]{2}$/

export const LEI_VALIDATION_MESSAGE = 'LEI must be a valid ISO 17442 identifier'

export function normalizeLei(value: string): string {
  return value.trim().toUpperCase()
}

export function isValidLei(value: string): boolean {
  const lei = normalizeLei(value)
  if (!LEI_SHAPE_PATTERN.test(lei)) return false

  let remainder = 0
  for (const ch of lei) {
    if (ch >= 'A' && ch <= 'Z') {
      const mapped = ch.charCodeAt(0) - 55
      remainder = (remainder * 100 + mapped) % 97
    } else {
      remainder = (remainder * 10 + (ch.charCodeAt(0) - 48)) % 97
    }
  }
  return remainder === 1
}
